// v7 · Ayudas para mostrar el plan de cada lead (mismas reglas que backend/lead_plan.py).

export const ACTION_LABEL = {
  preparar: "Preparar el contacto", seguir: "Seguir la cuenta", reaccionar_historia: "Reaccionar a una historia",
  me_gusta: "Dar me gusta", comentar: "Comentario", responder_historia: "Respuesta a una historia",
  mensaje_apertura: "Mensaje directo", audio: "Audio", responder: "Respuesta", recurso: "Recurso de valor",
  mencionar: "Mención", proponer_llamada: "Propuesta de llamada", proponer_colaboracion: "Propuesta de colaboración",
  enviar_info: "Información", seguimiento_reunion: "Seguimiento de la reunión", cambiar_canal: "Cambio de canal",
  pedir_recomendacion: "Petición de recomendación", pausar: "Pausa", no_contactar: "No contactar",
};
// Qué texto lleva cada acción ("" = ninguno).
export const ACTION_TEXT = {
  comentar: "comentario", responder_historia: "mensaje", mensaje_apertura: "mensaje", audio: "guion",
  responder: "mensaje", recurso: "mensaje", mencionar: "texto", proponer_llamada: "mensaje",
  proponer_colaboracion: "mensaje", enviar_info: "mensaje", seguimiento_reunion: "mensaje", cambiar_canal: "mensaje",
  pedir_recomendacion: "mensaje",
};
export const STAGE_LABEL = {
  preparar: "Preparar", calentar: "Calentar", abrir: "Abrir", conversar: "Conversar", proponer: "Proponer",
  seguimiento: "Seguimiento", cerrar: "Cerrar", cuidar: "Cuidar", pausa: "Pausa", retomar: "Retomar",
};
export const PHASE_LABEL = {
  calentar: "Fase 1 · Calentar", abrir: "Fase 2 · Abrir", conversar: "Fase 3 · Conversar",
  proponer: "Fase 4 · Proponer", cerrar: "Fase 5 · Cerrar", cuidar: "Fase 6 · Cuidar",
  reactivar: "Reactivar", pausa: "En pausa",
};
export const TODAY_GROUPS = [
  ["respuestas", "Respuestas pendientes"], ["calentar", "Calentar"],
  ["mensajes", "Mensajes nuevos"], ["seguimientos", "Seguimientos"],
];

export const stageTag = (stage) =>
  ["calentar", "preparar"].includes(stage) ? "c" : ["seguimiento", "pausa", "retomar"].includes(stage) ? "s" : "a";

const pad = (n) => String(n).padStart(2, "0");
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
const toDate = (iso) => { const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number); return new Date(y, m - 1, d); };
export function daysFromToday(iso) {
  return Math.round((toDate(iso) - toDate(todayISO())) / 864e5);
}
const WD = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
export function dayLabel(iso, { long = false } = {}) {
  if (!iso) return "";
  const n = daysFromToday(iso);
  const d = toDate(iso);
  const wd = WD[d.getDay()];
  const base = `${wd.charAt(0).toUpperCase() + wd.slice(1)} ${d.getDate()}`;
  if (n === 0) return long ? `Hoy, ${wd} ${d.getDate()}` : "Hoy";
  if (n === 1) return "Mañana";
  if (n < 0) return n === -1 ? "Ayer (atrasado)" : `Atrasado ${-n} días`;
  return base;
}

export function currentStep(plan) {
  const pend = (plan?.steps || []).filter((s) => s.status === "pending");
  const t = todayISO();
  return pend.find((s) => s.when && s.when <= t) || pend[0] || null;
}
export const visibleSteps = (plan) => (plan?.steps || []).filter((s) => s.status !== "skipped");
export const lastDone = (plan) => [...(plan?.steps || [])].reverse().find((s) => s.status === "done") || null;

export function firstName(name) {
  return String(name || "").split("·")[0].trim().split(/\s+/)[0] || "este contacto";
}
